import {
  Loader,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { TagItem } from "@components/custom/dropdowns";

export const TagsListSlide = ({
  tags = [],
  isFetching,
  onCreateClick,
  onEditClick,
  onDeleteClick,
  onClose,
}) => {
  return (
    <>
      {isFetching && <Loader overlay />}
      <ModalHeader
        className="blue-icon"
        icon={["fa-regular", "tags"]}
        title="Manage Device Tags"
      />
      <ModalBody>
        <div className="header-actions">
          <Button icon={["fa-regular", "plus"]} onClick={onCreateClick}>
            Create Tag
          </Button>
        </div>
        <div className="tags-list">
          {tags?.map((tag) => (
            <TagItem key={tag.id} value={tag}>
              <div className="tag-item-actions">
                <Button
                  borderless
                  icon={["fa-regular", "edit"]}
                  onClick={() => onEditClick(tag)}
                />
                <Button
                  borderless
                  icon={["fa-regular", "trash-can"]}
                  onClick={() => onDeleteClick(tag)}
                />
              </div>
            </TagItem>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>Cancel</Button>
        <Button primary onClick={onClose}>
          Done
        </Button>
      </ModalFooter>
    </>
  );
};
